import React from "react"
import PropTypes from "prop-types"
import { fromJS } from "immutable"
import ImPropTypes from "react-immutable-proptypes"
import { sanitizeUrl } from "core/utils"


class Path extends React.Component {
  static propTypes = {
    host: PropTypes.string,
    basePath: PropTypes.string
  }

  render() {
    let { host, basePath } = this.props

    return (
      <pre className="base-url">
        [ Base URL: {host}{basePath} ]
      </pre>
    )
  }
}


// class Contact extends React.Component {
//   static propTypes = {
//     data: PropTypes.object
//   }

//   render(){
//     let { data } = this.props
//     let name = data.get("name") || "the developer"
//     let url = data.get("url")
//     let email = data.get("email")

//     return (
//       <div>
//         { url && <div><a href={ sanitizeUrl(url) } target="_blank">{ name } - Website</a></div> }
//         { email &&
//           <a href={sanitizeUrl(`mailto:${email}`)}>
//             { url ? `Send email to ${name}` : `Contact ${name}`}
//           </a>
//         }
//       </div>
//     )
//   }
// }

class License extends React.Component {
  static propTypes = {
    license: PropTypes.object
  }

  render(){
    let { license } = this.props
    let name = license.get("name") || "License"
    let url = license.get("url")

    return (
      <div>
        {
          url ? <a target="_blank" href={ sanitizeUrl(url) }>{ name }</a>
        : <span>{ name }</span>
        }
      </div>
    )
  }
}

export default class Info extends React.Component {
  static propTypes = {
    info: PropTypes.object,
    url: PropTypes.string,
    host: PropTypes.string,
    basePath: PropTypes.string,
    externalDocs: ImPropTypes.map,
    getComponent: PropTypes.func.isRequired,
  }

  render() {
    let { info, url, host, basePath, getComponent, externalDocs } = this.props
    let version = info.get("version")
    // let description = info.get("description")
    let title = info.get("title")
    let termsOfService = info.get("termsOfService")
    // let contact = info.get("contact")
    let license = info.get("license")
    const { url:externalDocsUrl, description:externalDocsDescription } = (externalDocs || fromJS({})).toJS()

    const Markdown = getComponent("Markdown")
    const VersionStamp = getComponent("VersionStamp")

    return (
      <div className="info">
        <hgroup className="main">
          <h2 className="title" >{ title }
            { version && <VersionStamp version={version}></VersionStamp> }
          </h2>
          { host || basePath ? <Path host={ host } basePath={ basePath } /> : null }
          { url && <a target="_blank" href={ sanitizeUrl(url) } style={{display: "none"}}><span className="url"> { url } </span></a> }
        </hgroup>

        <div className="description">
          <Markdown source={ "This is the API document for **Evo-IP**, you can view all the categories to seek the one you need.\n" +
                             "### Note\n" +
                             "The API URL below like `/api (APIAutoAVSetting.GetExtenderLists)` has two parts:\n" +
                             "\n" +
                             "* You need to call `/login` before start to use the API\n" +
                             "  * Post a `form-data` with 2 keys\n" +
                             "    * `userid` with your user name as value \n" +
                             "    * `passwd` with your password as value\n" +
                             "  * And you should be able to use it once you get a json response `{\"code\":200,\"message\":\"OK\"}`\n" +
                             "* `/api` is the API URL to request\n" +
                             "* `(APIAutoAVSetting.GetExtenderLists)` is just the JSONRPC method for you to differ from others\n" +
                             "DO NOT add it to API URL please!\n" +
                             "### Change Log\n" +
                             "##### 20180920\n" +
                             "- Add following APIs\n" +
                             "  - APIAutoAVSetting.GetUserOSDList\n" +
                             "  - APIAutoAVSetting.AddUserOSDPhoto\n" +
                             "  - APIAutoAVSetting.DeleteUserOSDPhoto\n" +
                             "  - APIAutoAVSetting.SetExtenderResolutionCommand\n" +
                             "  - APIAutoAVSetting.SetExtenderEmailConfig\n" +
                             "  - APIAutoAVSetting.SetExtenderSMSConfig\n" +
                             "- Add `/upload` to upload files\n" +
                             "\n" +
                            "### 20190712\n" +
                            "* Add `APIAutoAVSetting.SetExtenderBaudRateCommand`\n" +
                            "* You can get baudrate value from `APIAutoAVSetting.GetExtenderSetting`\n" +
                            "\n"
         } />
        </div>

        {
          termsOfService && <div>
            <a target="_blank" href={ sanitizeUrl(termsOfService) }>Terms of service</a>
          </div>
        }

        { /* contact && contact.size ? <Contact data={ contact } /> : null */ }
        { license && license.size ? <License license={ license } /> : null }
        { externalDocsUrl ?
            <a target="_blank" href={sanitizeUrl(externalDocsUrl)}>{externalDocsDescription || externalDocsUrl}</a>
        : null }
      </div>
    )
  }

}

Info.propTypes = {
  title: PropTypes.any,
  description: PropTypes.any,
  version: PropTypes.any,
  url: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/core/components/info.jsx